import { Injectable, NgZone, inject } from '@angular/core';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';

@Injectable({ providedIn: 'root' })
export class TooltipAutoCloseService {
  private ngZone = inject(NgZone);

  private tooltips = new Set<NzTooltipDirective>();

  public constructor() {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('scroll', () => {
        this.tooltips.forEach(t => t.hide());
      }, { passive: true, capture: true });
    });
  }

  public register(tooltip: NzTooltipDirective): void {
    this.tooltips.add(tooltip);
  }

  public unregister(tooltip: NzTooltipDirective): void {
    this.tooltips.delete(tooltip);
  }
}